import {SxType} from "@baseTypes/sx/sxTypes";

const ACCENT = 'var(--account-accent, #0C6DDF)'

export const sx: SxType = {
    item: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        width: '100%',
        padding: '8px 10px',
        borderRadius: '10px',
        border: '1px solid transparent',
        transition: 'all .2s',
        cursor: 'pointer',
        '.lightTheme &': {
            backgroundColor: '#F7F9FC',
            color: '#1E1E1E',
        },
        '.darkTheme &': {
            backgroundColor: 'rgba(255, 255, 255, 0.04)',
            color: '#fff',
        },
        '&:hover': {
            borderColor: 'var(--account-accent-tint, rgba(12, 109, 223, 0.35))',
        },
        '.lightTheme .active &': {
            backgroundColor: 'var(--account-accent-soft, #E8F1FD)',
            borderColor: ACCENT,
        },
        '.darkTheme .active &': {
            backgroundColor: 'var(--account-accent-tint, rgba(12, 109, 223, 0.25))',
            borderColor: 'var(--account-accent-light, #90caf9)',
        },
    },
    iconWrap: {
        flexShrink: 0,
        width: '34px',
        height: '34px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'var(--account-accent-soft, rgba(12, 109, 223, 0.1))',
        '.active &': {
            backgroundColor: ACCENT,
        },
    },
    icon: {
        fontSize: '19px',
        color: ACCENT,
        '.active &': {
            color: '#fff',
        },
    },
    text: {
        flex: 1,
        minWidth: 0,
    },
    title: {
        fontSize: '14px',
        fontWeight: 600,
        lineHeight: 1.25,
    },
    description: {
        fontSize: '12px',
        lineHeight: 1.3,
        color: 'text.secondary',
    },
    chevron: {
        flexShrink: 0,
        fontSize: '20px',
        color: 'text.disabled',
        '.active &': {
            color: ACCENT,
        },
    },
}
